// extracted by mini-css-extract-plugin
export var boxItems = "_b6-1";
export var boxItemsLg = "_b6-2";
export var button = "_b6-7";
export var buttonLg = "_b6-8";
export var filterGroupBox = "_b6-0";
export var icon = "_b6-3";
export var iconSecondary = "_b6-6";
export var iconWrapper = "_b6-4";
export var iconWrapperLg = "_b6-5";